<template>
    <div
        class="editor-bar flex flex-col items-center justify-center rounded-lg p-2 px-4 min-w-[640px]  min-h-[84px] bg-white  z-999">
        <!-- top -->
        <div class="w-full h-full flex items-center justify-between p-1">
            <div class="flex items-center gap-2">
                <span class="icon-wrap !text-[12px] flex justify-center items-center">
                    重置
                </span>
                <!-- 撤销全部 -->
                <span class="icon-wrap ml-2 flex justify-center items-center" :class="{ disabled: disabled.undo }"
                    @click="() => store.dispatch('record/undo')">
                    <a-tooltip placement="bottom" :title="t('common.prevStep')">
                        <span class="i-bx:bx-undo icon"></span>
                    </a-tooltip>
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.redo }"
                    @click="() => store.dispatch('record/redo')">
                    <a-tooltip placement="bottom" :title="t('common.nextStep')">
                        <span class="i-bx:bx-redo icon"></span>
                    </a-tooltip>
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }"
                    @click="showAgainModal = true">
                    <a-tooltip placement="bottom" :title="t('common.withdrawAll')">
                        <span class="i-fluent:history-16-filled icon !text-5"></span>
                    </a-tooltip>
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/cut-icon.svg" height="20" width="20" alt />
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/layer-icon.svg" height="20" width="20" alt />
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/brush-icon.svg" height="20" width="20" alt />
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/action-icon.svg" height="20" width="20" alt />
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/text-icon.svg" height="20" width="20" alt />
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/position-icon.svg" height="20" width="20" alt />
                </span>
                <a-divider type="vertical" style="height: 20px; background-color: #dadde1" />
                <div class="flex items-center gap-2">
                    <span class=" !text-[12px] flex justify-center items-center">
                        颜色
                    </span>
                    <span class="inline-block w-4 h-4 bg-blue"></span>
                </div>

            </div>
            <div class="flex items-center">
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/upload-icon.svg" height="20" width="20" alt />
                </span>
                <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                    <img src="@/assets/icons/action3-icon.svg" height="20" width="20" alt />
                </span>
            </div>
        </div>
        <a-divider />

        <!-- bottom -->
        <div class="w-full h-full flex items-center gap-2 p-1">
            <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                <img src="@/assets/icons/action2-icon.svg" height="20" width="20" alt />
            </span>
            <span class="icon-wrap flex justify-center items-center" :class="{ disabled: disabled.again }">
                <img src="@/assets/icons/xiangpi-icon.svg" height="20" width="20" alt />
            </span>
            <div class="w-[150px] flex  items-center">
                <span>粗细</span>
                <a-slider class="flex-1" id="test" v-model:value="sliderValue" />

            </div>
            <div class="border-1 border-[#CFD2DA] rounded-[6px] ">
                <Scaler></Scaler>
            </div>
            <div class="flex items-center gap-2">
                <span>最近使用</span>
                <div class="flex items-center gap-1">
                    <span class="inline-block w-4 h-4 bg-blue"></span>
                    <span class="inline-block w-4 h-4 bg-green"></span>
                    <span class="inline-block w-4 h-4 bg-gray"></span>
                </div>
            </div>
        </div>
        <a-modal v-model:visible="showAgainModal" :cancel-text="t('common.cancel')" :ok-text="t('common.confirm')"
            :title="t('common.withdrawAllDialogTitle')" @ok="doAgain" @cancel="showAgainModal = false">
            <p>{{ t('common.withdrawAllDialogContent') }}</p>
        </a-modal>
    </div>
</template>
<script setup>
import { computed, ref } from 'vue';
import i18n from '@/locales/i18n';
import { useStore } from 'vuex';
import { getEditorDataByRequestIdLocal } from '@/utils/ls';
import Scaler from '@/components/Header/Scaler.vue';


const props = defineProps({

});
const emit = defineEmits(['switch-image', 'remove-image', 'reorder', 'insert-blank']);

const { t } = i18n.global;

const showAgainModal = ref(false);

const store = useStore();
const sliderValue = ref(6)

const appState = computed(() => store.state.app);
const disabled = computed(() => {
    const { requestId } = store.state.multi;
    const { currentIndex, history } = store.state.record;
    return {
        undo: currentIndex <= 0,
        redo: currentIndex >= history.length - 1,
        again: !getEditorDataByRequestIdLocal(requestId) && currentIndex <= 0,
    };
});

const doAgain = () => {
    showAgainModal.value = false;
    const { requestId } = store.state.multi;
    store.dispatch('user/setCache', {
        requestId,
        v: JSON.stringify(null),
    });
    store.dispatch('app/setGroupState', false);
    store.commit('app/SET_DRAWING_MODE', false);
    store.commit('app/SET_STATE', { isDraw2CancelTransMode: false, isAiInpaintMode: false });
    store.dispatch('app/discardActiveObject');
    store.dispatch('record/doAgain');
};
</script>
<style lang="less" scoped>
.editor-bar {
    :deep(.ant-divider) {
        &.ant-divider-horizontal {
            margin: 0;
        }

    }

    .icon-wrap {
        padding: 3px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 22px;
        vertical-align: middle;
        cursor: pointer;
        width: 36px;
        height: 36px;
        line-height: 36px;
        transition: background-color 0.25s, color 0.25s;
        border-radius: 4px;

        &:hover {
            background: #f1f2f4;
        }

        &.disabled {
            opacity: 0.3;
            pointer-events: none;
        }
    }
}
</style>